export default "__VITE_ASSET__bde78745__"